/*
  TOSSIT link prefetch
  ====================
  Replaces the "asset preloading" TinyIMG advertised but never wired up — its
  tiny-img-link-preloader.js sat in assets/ with nothing referencing it, so the
  storefront was paying for the feature in the app bill and getting none of it.

  When a pointer settles on an internal link, fetch that page in the background
  so the click lands on a warm cache. Hover-to-click is rarely under ~200ms, so
  a short intent delay buys most of the win without prefetching every link the
  cursor happens to cross on its way somewhere else.

  Deliberately conservative about what it will touch:

  - Same-origin only. Never another host, never a download, never a new tab.
  - Never anything that mutates state or is personal: cart, checkout, account,
    logout, the app-proxy prefix, and any URL carrying a query string (discount
    links, ?variant=, Klaviyo attribution) — prefetching those either burns a
    one-time token or caches a page keyed to somebody's session.
  - Off entirely under Save-Data or on 2g, where the extra request is the
    opposite of a favour.
  - Each URL once, capped per page, so a long collection grid cannot turn a
    slow scroll into fifty requests.
*/

(function () {
  var INTENT_DELAY = 65;
  var MAX_PREFETCHES = 30;

  var link = document.createElement('link');
  var supported = !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  if (!supported) return;

  var conn = navigator.connection;
  if (conn) {
    if (conn.saveData) return;
    if (/2g/.test(conn.effectiveType || '')) return;
  }

  // 'discount' matters as much as 'cart': /discount/CODE applies the code and
  // redirects, so warming it on hover would spend the code without a click.
  var SKIP = /^\/(cart|checkout|account|orders|discount|gift_cards|recover|apps|a|admin|tools|password|challenge)(\/|$)/;
  var seen = {};
  var count = 0;
  var timer = null;

  // §1 — is this a link we are willing to warm?

  function prefetchable(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.origin !== window.location.origin) return false;

    if (a.search) return false;
    if (SKIP.test(a.pathname)) return false;
    if (a.pathname === window.location.pathname) return false;
    if (seen[a.pathname]) return false;

    return true;
  }

  // §2 — the fetch itself

  function prefetch(url) {
    if (count >= MAX_PREFETCHES) return;
    seen[url] = true;
    count++;

    var el = document.createElement('link');
    el.rel = 'prefetch';
    el.href = url;
    el.as = 'document';
    document.head.appendChild(el);
  }

  function closestLink(target) {
    return target && target.closest ? target.closest('a') : null;
  }

  // §3 — intent. Pointer devices wait out the delay; touch fires on contact,
  // where the gap between touchstart and the click is already the whole win.

  document.addEventListener(
    'mouseover',
    function (e) {
      var a = closestLink(e.target);
      if (!prefetchable(a)) return;

      var url = a.pathname;
      clearTimeout(timer);
      timer = setTimeout(function () {
        prefetch(url);
      }, INTENT_DELAY);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'mouseout',
    function () {
      clearTimeout(timer);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchstart',
    function (e) {
      var a = closestLink(e.target);
      if (!prefetchable(a)) return;
      prefetch(a.pathname);
    },
    { capture: true, passive: true }
  );
})();
